import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M9.2 1.2l-6 6c-.2.2-.2.51 0 .71s.51.2.71 0l5.14-5.15v15.79c0 .27.22.5.5.5s.5-.23.5-.5V2.76l5.15 5.15c.2.2.51.2.71 0s.2-.51 0-.71l-6-6c-.2-.2-.51-.2-.71 0z',
  ],
  height: 20,
  width: 20,
});
